import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, { Assinatura, Botao as BotaoForm } from 'Component/Form';
import Imagem from 'Component/Imagem';
import FechamentoDeFolha from 'Interface/FechamentosDeFolha';
import {
  useEditarFechamentoDeFolhaMutation,
  useRecuperarFechamentoDeFolhaQuery,
} from 'View/Service/Default/FechamentosDeFolha';

const regras = object({
  assinatura: string().required('Obrigatório'),
});

const Assinar = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const toast = useToast();
  const navegacao = useNavigate();

  const [editarFolha] = useEditarFechamentoDeFolhaMutation();

  const { data: { fechamento_de_folha } = {} } =
    useRecuperarFechamentoDeFolhaQuery(id);

  const enviar = async (dados: FechamentoDeFolha): Promise<void> => {
    try {
      await editarFolha({
        ...dados,
        assinatura: dados.assinatura,
        assinado: 1,
        data_da_assinatura: DateTime.now().toISO(),
      }).unwrap();

      navegacao('/fechamentos-de-folha/historico');
    } catch (erro) {
      toast({
        tema: 'danger',
        titulo: 'Erro ao assinar',
        conteudo: 'Verifique os logs para mais informações',
      });
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center py-5">
        <div className="col-md-5">
          <h1 className="text-center">Assinar fechamento de olha</h1>
          <p className="text-center">
            Faça sua assinatura no campo abaixo para assinar seu arquivo de
            fechamento de folha.
          </p>
          <Form
            onSubmit={enviar}
            regras={regras}
            inicial={fechamento_de_folha}
            desabilitado={fechamento_de_folha?.assinado == 1}
          >
            {fechamento_de_folha?.assinado ? (
              <Imagem
                src={fechamento_de_folha.assinatura}
                className="img-fluid"
              />
            ) : (
              <Assinatura name="assinatura" rotulo="Assinatura" />
            )}
            <div className="text-center">
              <BotaoForm>Assinar</BotaoForm>{' '}
            </div>
          </Form>
          <div className="text-center mt-3">
            <BotaoLink to="/fechamentos-de-folha/historico" tema="light">
              Cancelar
            </BotaoLink>{' '}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assinar;
